import { createSelector } from '@reduxjs/toolkit'
import type { Workspace } from '@store/reducers/dashboard/types'

import { selectWorkspaceId } from '../utils/selectIds'
import { selectDashboard } from './selectDashboard'

export const getMembers = createSelector(
  [selectDashboard, selectWorkspaceId],
  (dashboard, workspaceId) => {
    const workspace: Workspace | undefined = dashboard.find(
      (workspace) => workspace.id === workspaceId
    )

    if (!workspace) {
      return []
    }

    return workspace.members
  }
)
